module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/capa-g1-69a84d5732a32e272e501373d8cfc4e2.png";